<template>
  <b-modal
    @hide="closePopup"
    ref="instructionModal"
    dialog-class="info-modal__dialog"
    content-class="info-modal__content info-modal__content--hidden custom-modal-padding"
    body-class="info-modal pt-0"
    modal-class="info-modal info-modal--small"
    size="md"
    v-if="visible"
    :visible="visible"
    no-fade
    hide-body
    hide-header
    hide-footer
    hide-header-close
  >
    <button class="btn-close" @click="closePopup">
     <svg class="svg-popup-close-button" width="25" height="25" viewBox="0 0 25 25" fill="" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.8811 12.5L24.714 1.66715C25.0954 1.28575 25.0954 0.667394 24.714 0.286047C24.3326 -0.0953001 23.7142 -0.0953489 23.3329 0.286047L12.5 11.1189L1.66715 0.286047C1.28575 -0.0953489 0.667394 -0.0953489 0.286047 0.286047C-0.0953001 0.667443 -0.0953489 1.2858 0.286047 1.66715L11.1189 12.5L0.286047 23.3329C-0.0953489 23.7143 -0.0953489 24.3326 0.286047 24.714C0.47672 24.9047 0.726671 25 0.976622 25C1.22657 25 1.47647 24.9047 1.6672 24.714L12.5 13.8811L23.3328 24.714C23.5235 24.9047 23.7735 25 24.0234 25C24.2734 25 24.5233 24.9047 24.714 24.714C25.0954 24.3326 25.0954 23.7142 24.714 23.3329L13.8811 12.5Z" />
      </svg>
    </button>
    <div class="info-modal__body">
      <div class="info-modal__head">
        <h1 class="info-modal__title">{{title ? title : ''}}</h1>
      </div>
      <img class="info-modal_image--pwa" :src="logoIcon" alt="app-icon"/>
      <p class="head__title head__title--pwa" v-html="$t('message[\'popup.pwa.title\']')"></p>
      <hr/>

      <div class="info-modal-wrap">
        <div class="info-modal-wrap__first-text d-flex justify-content-center">
          <p>{{ $t('message["popup.pwa.tap"]') }}</p>
          <img :src="imagesUrl + 'logo-icon/export-icon.svg'" alt="download"/>
          <p>{{ $t('message["popup.pwa.text-1"]') }}</p>
        </div>
        <div class="info-modal-wrap__second-text d-flex justify-content-center">
          <p>{{ $t('message["popup.pwa.text-2"]') }}</p>
          <img :src="imagesUrl + 'logo-icon/add-icon.svg'" alt="add"/>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

import popupAnimationMixin from '../../../../../mixins/popupAnimationMixin'

export default {
  name: 'PwaPopup',
  props: ['visible', 'title'],
  mixins: [popupAnimationMixin],
  data: function () {
    return {
      imagesUrl: this.$appConfig.imagesUrl,
      logoIcon: this.$appConfig.imagesUrl + 'logo-icon/default-icon.png'
    }
  },
  mounted () {
    const manifest = $("link[rel='manifest']")
    if (manifest.length > 0 && typeof manifest.eq(0).attr('href') !== 'undefined') {
      this.readTextFile(manifest.eq(0).attr('href'), (text) => {
        try {
          const data = JSON.parse(text)
          this.logoIcon = data.icons[0].src || this.$appConfig.imagesUrl + 'logo-icon/default-icon.png'
        } catch (e) {
          this.logoIcon = this.$appConfig.imagesUrl + 'logo-icon/default-icon.png'
        }
      })
    }
  },
  methods: {
    closePopup (e) {
      if (e) {
        e.preventDefault()
      }
      this.closeAnimatedPopup(() => {
        this.$emit('close')
      })
    },
    readTextFile (file, callback) {
      const rawFile = new XMLHttpRequest()
      rawFile.overrideMimeType('application/json')
      rawFile.open('GET', file, true)
      rawFile.onreadystatechange = function () {
        if (rawFile.readyState === 4) {
          callback(rawFile.responseText)
        }
      }
      rawFile.send(null)
    }
  }
}
</script>
